import { render, staticRenderFns } from "./SlotForm.vue?vue&type=template&id=1d4019a2"
import script from "./SlotForm.vue?vue&type=script&lang=ts"
export * from "./SlotForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports